var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAamSquares(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 222,
    viewBox: "0 0 332 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 47,
    y: 15,
    width: 25,
    height: 25,
    fill: "#F2F2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 180,
    width: 20,
    height: 20,
    fill: "#D0D0D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212 60H72V200H212V60ZM181 91H103V169H181V91Z",
    fill: "#BD0057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332 0H272V60H332V0ZM318.714 13.2857H285.286V46.7143H318.714V13.2857Z",
    fill: "#FC4E6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 180H0V222H42V180ZM32.7 189.3H9.29995V212.7H32.7V189.3Z",
    fill: "#FC4E6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAamSquares);
export default __webpack_public_path__ + "static/media/AAM-squares.8ac2ba904a6ed5b4e84ed08b040214f3.svg";
export { ForwardRef as ReactComponent };